import type { CombinedError } from '@urql/core'

export type GqlError = {
  path?: readonly (string | number)[]
  message: string
}

type ErrorCollection = Record<string, GqlError> & { global?: GqlError }
type UnpackErrors = (errors: (CombinedError | GqlError)[]) => ErrorCollection

const reduceSimple = (acc: ErrorCollection, error: GqlError) => {
  const { path, message: rawMsg } = error
  const message = rawMsg?.replace('[GraphQL] ', '')

  // validation errors on forms
  if (path?.[0] === 'attributes') {
    const key = path[1]
    acc[key] = error

    return acc
  }

  if (!message) {
    return acc
  }

  if (!acc.global) {
    acc.global ||= new Error()
    acc.global.message = ''
  }

  if (acc.global.message) {
    acc.global.message += ', '
  }

  acc.global.message += message

  return acc
}

const reduceCombined = (acc: ErrorCollection, error: CombinedError) => {
  let augmented = acc
  error.graphQLErrors?.forEach((err) => {
    augmented = reduceSimple(augmented, err)
  })

  if (error.networkError) {
    augmented = reduceSimple(augmented, error.networkError)
  }

  if (error.graphQLErrors?.length > 0 || error.networkError) {
    return augmented
  }

  return reduceSimple(augmented, error)
}

const unpackErrors: UnpackErrors = (errors) => errors.reduce<ErrorCollection>(reduceCombined, {})

export default unpackErrors
